import { useState } from "react";
import SipCalculator from "../Pages/SipCalculator";
import ZeroCommissionSection from "../components/ZeroCommissionSection";
import { useNavigate } from "react-router-dom";

const MutualFundPage = () => {
  const top5Funds = [
    { name: "Nippon India Growth Fund", return: "23.20%" },
    { name: "Parag Parikh Flexi Cap Fund", return: "21.10%" },
    { name: "Nippon India Multi Cap Fund", return: "20.80%" },
    { name: "ICICI Pru Equity & Debt Fund", return: "18.50%" },
    { name: "HDFC Mid Cap Opportunities Fund", return: "22.18%" },
  ];

  const navigate = useNavigate();

  return (
    <div className="w-full bg-black-main-dark text-gray-200">
      {/* ================= HERO ================= */}
      <section className="min-h-screen flex flex-col justify-center items-center text-center px-6">
        <h1 className="text-4xl sm:text-5xl md:text-7xl xl:text-8xl font-bold text-white mb-8">
          Build{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary1 to-secondary">
            Wealth
          </span>
          , SIP by SIP.
        </h1>

        <p className="mb-12 text-base sm:text-lg text-gray-300 max-w-3xl">
          We help you choose the right mutual funds based on your goals, time
          horizon, and risk comfort with a disciplined approach.
        </p>

        <button
          onClick={() => navigate("/mutual-fund-check")}
          className="px-8 py-4 bg-primary1 text-black rounded-2xl text-lg font-medium"
        >
          Start Investing
        </button>
      </section>

      {/* ================= WHAT WE HELP WITH ================= */}
      <section
        id="what-we-help"
        className="border border-black-dark-200 w-full rounded-3xl py-24"
      >
        <div className="text-center max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white">
            What We <span className="text-primary1">Help</span> With
          </h2>

          <p className="mt-6 text-gray-300 max-w-3xl mx-auto">
            Clear, goal-based mutual fund investing without noise or pressure.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mt-14">
            {[
              "SIP planning",
              "Lumpsum investing",
              "Goal-based portfolios",
              "Tax-efficient investing",
            ].map((item) => (
              <div
                key={item}
                className="bg-black-dark-500 border border-gray-800 rounded-2xl p-6 text-lg"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="border border-black-dark-200 w-full rounded-3xl py-24 mt-36">
        <div className="text-center max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-14">
            How it <span className="text-primary1">Works</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              "Understand your goals",
              "Suggest suitable funds",
              "Review periodically",
            ].map((text, index) => (
              <div
                key={text}
                className="bg-black-dark-500 border border-gray-800 rounded-2xl p-6"
              >
                <div className="text-primary1 font-semibold mb-2">
                  Step {index + 1}
                </div>
                <p className="text-gray-300">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= SIP CALCULATOR ================= */}
      <section className="my-24">
        <SipCalculator />
      </section>

      {/* ================= ZERO COMMISSION ================= */}
      <section className="my-24">
        <ZeroCommissionSection topFunds={top5Funds} />
      </section>
    </div>
  );
};

export default MutualFundPage;
